import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export const NumberContainer = styled.div`
    display: flex;
`;

export const Arrow = styled.img`
    cursor: pointer;

    transition: opacity 0.1s ease-in-out;

    &:hover {
        opacity: 0.5;
    }

    ${({ disabled }) =>
        disabled &&
        `
        cursor: not-allowed;
        opacity: 0.1;
    `}
`;

export const Number = styled.div`
    margin: 0 2px;
    padding: 8px 16px;

    cursor: pointer;

    transition: background 0.1s ease-in-out;

    ${({ active }) =>
        active &&
        `
        color: white;
        background: var(--color-darkNight);
    `}
`;
